import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import { useTimeZoneStore } from '../store/useTimeZoneStore'
import { useToFill } from './shared/useToFill'
import { localMonthApiRange, localHlyKey } from '../utils/timeUtils'

function daysInMonth(year, month) {
  return new Date(year, month, 0).getDate()
}

export function useHlyOneMonthData(ghId, year, month, tsId = 'HLY_TEMP') {
  const tz = useTimeZoneStore(s => s.tz)
  const { begin_date, end_date } = localMonthApiRange(year, month, tz)

  const queryKey = ['hlyData', tsId, ghId, year, month, tz]

  const { data, isLoading, isError, error } = useQuery({
    queryKey,
    queryFn: () => api.get(
      `/daily_ts?ts_id=${tsId}&gh_id=${ghId}&begin_date=${begin_date}&end_date=${end_date}`
    ).then(r => ({ result: r.data ?? [], toFill: r.to_fill ?? [] })),
    enabled: !!ghId,
    staleTime: 5 * 60 * 1000,
  })

  useToFill(queryKey, data, (_result, resp) => resp.data)

  // dataMap: UTC "YYYY-MM-DD HH" → value
  // localToUtcMap: local "YYYY-MM-DD HH" → UTC "YYYY-MM-DD HH"  (first occurrence wins on DST fall-back)
  const dataMap       = new Map()
  const localToUtcMap = new Map()
  ;(data?.result ?? []).forEach(row => {
    if (row.dt == null) return
    const dt     = new Date(row.dt)
    const utcKey = `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, '0')}-${String(dt.getUTCDate()).padStart(2, '0')} ${String(dt.getUTCHours()).padStart(2, '0')}`
    dataMap.set(utcKey, row.value ?? null)
    const lk = localHlyKey(dt, tz)
    if (!localToUtcMap.has(lk)) localToUtcMap.set(lk, utcKey)
  })

  return { dataMap, localToUtcMap, days: daysInMonth(year, month), isLoading, isError, error }
}
